//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import zap from './components/zap.vue'

export default {
  name: 'LayoutDefault',

  components: {
    zap
  },

  data () {
    return {
      leftDrawerOpen: false
    }
  }
}
